import axios from 'axios'
import BaseAPI from './base/base-api'

/**
 * Đầu api để gọi vào controller: TaxReturnRegisHistoryController
 */
class TaxReturnRegisHistoryAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'DeclareAPI';
    controllerName = 'TaxReturnRegisHistory';
}

export default new TaxReturnRegisHistoryAPI();